// extracted by mini-css-extract-plugin
export var conversationListItem = "_wl-2";
export var fullBleedList = "_wl-3";
export var messageText = "_wl-1";
export var previewText = "_wl-0";